import { COMPANY_DETAILS } from '../constants/companyDetails.js';
import { FACEBOOK, LINKEDIN, YOUTUBE, INSTAGRAM, TWITTER } from '../constants/socialMediaLinks.js';
import { IMG_BASE_URL } from '../constants/misc.js';

// Constants
function getSchemaOrgJson({ name = "Vahak | Best Road Transportation Marketplace", path = "", description = "India's no 1 online transport app ! Best mobile app to find truck loads online. Book trucks, containers through our online truck portal", type = "Organization", headline = "", image = `${IMG_BASE_URL}/vahak-timeline_gvlxfa.png`, breadcrumbList = "[]" }) {
    if (breadcrumbList == "[]") {
        return `[
            {
                "@context": "https://schema.org",
                "@type": "${type}",
                "name": "${name}",
                "url": "${COMPANY_DETAILS.website}${path}",
                "description": "${description}",
                "address": {
                    "@type": "PostalAddress",
                    "streetAddress": "${COMPANY_DETAILS.workspace}, ${COMPANY_DETAILS.address}",
                    "addressLocality": "${COMPANY_DETAILS.addressLocality}",
                    "addressRegion": "${COMPANY_DETAILS.addressRegion}",
                    "postalCode": "${COMPANY_DETAILS.postalCode}",
                    "addressCountry": "${COMPANY_DETAILS.addressCountry}"
                },
                "contactPoint": {
                    "@type": "ContactPoint",
                    "telephone": "${COMPANY_DETAILS.telephone}",
                    "contactType": "Customer Support"
                },
                "sameAs": [
                    "${FACEBOOK}",
                    "${LINKEDIN}",
                    "${YOUTUBE}",
                    "${INSTAGRAM}",
                    "${TWITTER}"
                ],
                "potentialAction": {
                    "@type": "SearchAction",
                    "target": {
                      "@type": "EntryPoint",
                      "urlTemplate": "${COMPANY_DETAILS.potentialActionTargetUrl}/{search_term_string}"
                    },
                    "query-input": "required name=search_term_string"
                }
            }
        ]`;
    }
    else {
        return `[
                    {
                        "@context": "https://schema.org",
                        "@type": "${type}",
                        "name": "${name}",
                        "url": "${COMPANY_DETAILS.website}${path}",
                        "description": "${description}",
                        "address": {
                            "@type": "PostalAddress",
                            "streetAddress": "${COMPANY_DETAILS.workspace}, ${COMPANY_DETAILS.address}",
                            "addressLocality": "${COMPANY_DETAILS.addressLocality}",
                            "addressRegion": "${COMPANY_DETAILS.addressRegion}",
                            "postalCode": "${COMPANY_DETAILS.postalCode}",
                            "addressCountry": "${COMPANY_DETAILS.addressCountry}"
                        },
                        "contactPoint": {
                            "@type": "ContactPoint",
                            "telephone": "${COMPANY_DETAILS.telephone}",
                            "contactType": "Customer Support"
                        },
                        "sameAs": [
                            "${FACEBOOK}",
                            "${LINKEDIN}",
                            "${YOUTUBE}",
                            "${INSTAGRAM}",
                            "${TWITTER}"
                        ],
                        "potentialAction": {
                            "@type": "SearchAction",
                            "target": {
                            "@type": "EntryPoint",
                            "urlTemplate": "${COMPANY_DETAILS.potentialActionTargetUrl}/{search_term_string}"
                            },
                            "query-input": "required name=search_term_string"
                        }
                    },
                    {
                        "@context": "https://schema.org",
                        "@type": "BreadcrumbList",
                        "itemListElement": ${breadcrumbList}
                    }
                ]`;
    }
}

export { getSchemaOrgJson };
//# sourceMappingURL=getSchemaOrgJson.js.map
